import React from 'react';
import BasicModal from '../../atoms/BasicModal';
import { DocumentDetailsForModal } from '../../../pages/ReconciliationWorkspace/ReconciliationWorkspace.types';
import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Worker, Viewer, SpecialZoomLevel } from '@react-pdf-viewer/core';
import { NoDataVisual } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import { scrollBarStyles } from '../../../core-utils/messages/CommonConstants';
import { PDF_WORKER_URL } from '../../../core-utils/helper-utils/pdfWorker';

interface DocumentViewModalProps {
  open: boolean;
  handleClose: () => void;
  documentDetails: DocumentDetailsForModal;
}

const useStyles = makeStyles()({
  documentViewGrid: {
    padding: '0px',
    width: '100%',
    height: '500px',
    overflowY: 'auto',
    ...scrollBarStyles,
    '& .rpv-core__inner-pages': {
      overflow: 'visible !important',
    },
    '& .rpv-core__viewer': {
      overflow: 'visible !important',
    },
  },
});

const DocumentViewModal: React.FC<DocumentViewModalProps> = ({
  open,
  handleClose,
  documentDetails,
}) => {
  const { classes } = useStyles();
  return (
    <BasicModal
      open={open}
      handleClose={handleClose}
      title={documentDetails.title}
      isSaveButton={false}
      isCloseBtn={false}
      height="auto"
      width="800px"
    >
      <Grid className={classes.documentViewGrid}>
        <Grid style={{ height: 'fit-content' }}>
          {documentDetails?.url !== '' && (
            <Worker workerUrl={PDF_WORKER_URL}>
              <Viewer
                fileUrl={documentDetails?.url}
                defaultScale={SpecialZoomLevel.PageWidth}
                renderPage={(props) => (
                  <>
                    {props.canvasLayer.children}
                    {props.textLayer.children}
                  </>
                )}
              />
            </Worker>
          )}
          {documentDetails?.url === '' && (
            <NoDataVisual content="NO FILE FOUND" />
          )}
        </Grid>
      </Grid>
    </BasicModal>
  );
};

export default DocumentViewModal;
